export const SETCREDENTIALLIST = "SETCREDENTIALLIST";
export const SETCONTENTLIST = "SETCONTENTLIST";